import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // create_payment_intent
  isLoadingCreatePaymentIntent: false,
  paymentIntent: null,
  errorCreatePaymentIntent: false,

  // confirm_subscription
  isLoadingConfirmSubscription: false,
  confirmSubscriptionResult: null,
  errorConfirmSubscription: false,

  // verify_subscription
  isLoadingVerifySubscription: false,
  verifySubscription: null,
  errorVerifySubscription: false,

  // subscription_status (GET)
  isLoadingSubscriptionStatus: false,
  subscriptionStatus: null,
  errorSubscriptionStatus: false,

  // cancel_subscription (POST)
  isLoadingCancelSubscription: false,
  cancelSubscriptionResult: null,
  errorCancelSubscription: false,

  // resume_subscription (POST)
  isLoadingResumeSubscription: false,
  resumeSubscriptionResult: null,
  errorResumeSubscription: false,

  // invoices (GET)
  isLoadingInvoices: false,
  invoices: [],
  errorInvoices: false,

  // confirm_payment (POST)
  isLoadingConfirmPayment: false,
  confirmPaymentResult: null,
  errorConfirmPayment: false,

  // upgrade_quote (POST)
  isLoadingUpgradeQuote: false,
  upgradeQuote: null,
  errorUpgradeQuote: false,

  // create_upgrade_intent (POST)
  isLoadingCreateUpgradeIntent: false,
  upgradePaymentIntent: null,
  errorCreateUpgradeIntent: false,

  // confirm_upgrade_after_payment (POST)
  isLoadingConfirmUpgradeAfterPayment: false,
  confirmUpgradeAfterPaymentResult: null,
  errorConfirmUpgradeAfterPayment: false,
};

export const paymentsSlice = createSlice({
  name: "payments",
  initialState,
  reducers: {
    // ---------------------------
    // create_payment_intent
    // ---------------------------
    startCreatePaymentIntent: (state) => {
      state.isLoadingCreatePaymentIntent = true;
      state.errorCreatePaymentIntent = false;
    },
    createPaymentIntentSuccess: (state, action) => {
      state.paymentIntent = action.payload;
      state.isLoadingCreatePaymentIntent = false;
    },
    createPaymentIntentError: (state, action) => {
      state.errorCreatePaymentIntent = action.payload || true;
      state.isLoadingCreatePaymentIntent = false;
    },
    resetCreatePaymentIntent: (state) => {
      state.paymentIntent = null;
      state.errorCreatePaymentIntent = false;
      state.isLoadingCreatePaymentIntent = false;
    },

    // ---------------------------
    // confirm_subscription
    // ---------------------------
    startConfirmSubscription: (state) => {
      state.isLoadingConfirmSubscription = true;
      state.errorConfirmSubscription = false;
    },
    confirmSubscriptionSuccess: (state, action) => {
      state.confirmSubscriptionResult = action.payload;
      state.isLoadingConfirmSubscription = false;
    },
    confirmSubscriptionError: (state, action) => {
      state.errorConfirmSubscription = action.payload || true;
      state.isLoadingConfirmSubscription = false;
    },
    resetConfirmSubscription: (state) => {
      state.confirmSubscriptionResult = null;
      state.errorConfirmSubscription = false;
      state.isLoadingConfirmSubscription = false;
    },

    // ---------------------------
    // verify_subscription
    // ---------------------------
    startVerifySubscription: (state) => {
      state.isLoadingVerifySubscription = true;
      state.errorVerifySubscription = false;
    },
    verifySubscriptionSuccess: (state, action) => {
      state.verifySubscription = action.payload;
      state.isLoadingVerifySubscription = false;
    },
    verifySubscriptionError: (state, action) => {
      state.errorVerifySubscription = action.payload || true;
      state.isLoadingVerifySubscription = false;
    },
    resetVerifySubscription: (state) => {
      state.verifySubscription = null;
      state.errorVerifySubscription = false;
      state.isLoadingVerifySubscription = false;
    },

    // ---------------------------
    // subscription_status (GET)
    // ---------------------------
    startSubscriptionStatus: (state) => {
      state.isLoadingSubscriptionStatus = true;
      state.errorSubscriptionStatus = false;
    },
    subscriptionStatusSuccess: (state, action) => {
      state.subscriptionStatus = action.payload;
      state.isLoadingSubscriptionStatus = false;
    },
    subscriptionStatusError: (state, action) => {
      state.errorSubscriptionStatus = action.payload || true;
      state.isLoadingSubscriptionStatus = false;
    },
    resetSubscriptionStatus: (state) => {
      state.subscriptionStatus = null;
      state.errorSubscriptionStatus = false;
      state.isLoadingSubscriptionStatus = false;
    },

    // ---------------------------
    // cancel_subscription (POST)
    // ---------------------------
    startCancelSubscription: (state) => {
      state.isLoadingCancelSubscription = true;
      state.errorCancelSubscription = false;
    },
    cancelSubscriptionSuccess: (state, action) => {
      state.cancelSubscriptionResult = action.payload;
      state.isLoadingCancelSubscription = false;
    },
    cancelSubscriptionError: (state, action) => {
      state.errorCancelSubscription = action.payload || true;
      state.isLoadingCancelSubscription = false;
    },
    resetCancelSubscription: (state) => {
      state.cancelSubscriptionResult = null;
      state.errorCancelSubscription = false;
      state.isLoadingCancelSubscription = false;
    },

    // ---------------------------
    // resume_subscription (POST)
    // ---------------------------
    startResumeSubscription: (state) => {
      state.isLoadingResumeSubscription = true;
      state.errorResumeSubscription = false;
    },
    resumeSubscriptionSuccess: (state, action) => {
      state.resumeSubscriptionResult = action.payload;
      state.isLoadingResumeSubscription = false;
    },
    resumeSubscriptionError: (state, action) => {
      state.errorResumeSubscription = action.payload || true;
      state.isLoadingResumeSubscription = false;
    },
    resetResumeSubscription: (state) => {
      state.resumeSubscriptionResult = null;
      state.errorResumeSubscription = false;
      state.isLoadingResumeSubscription = false;
    },

    // ---------------------------
    // invoices (GET)
    // ---------------------------
    startListInvoices: (state) => {
      state.isLoadingInvoices = true;
      state.errorInvoices = false;
    },
    listInvoicesSuccess: (state, action) => {
      state.invoices = Array.isArray(action.payload) ? action.payload : [];
      state.isLoadingInvoices = false;
    },
    listInvoicesError: (state, action) => {
      state.errorInvoices = action.payload || true;
      state.isLoadingInvoices = false;
    },
    resetInvoices: (state) => {
      state.invoices = [];
      state.errorInvoices = false;
      state.isLoadingInvoices = false;
    },

    // ---------------------------
    // confirm_payment (POST)
    // ---------------------------
    startConfirmPayment: (state) => {
      state.isLoadingConfirmPayment = true;
      state.errorConfirmPayment = false;
    },
    confirmPaymentSuccess: (state, action) => {
      state.confirmPaymentResult = action.payload;
      state.isLoadingConfirmPayment = false;
    },
    confirmPaymentError: (state, action) => {
      state.errorConfirmPayment = action.payload || true;
      state.isLoadingConfirmPayment = false;
    },
    resetConfirmPayment: (state) => {
      state.confirmPaymentResult = null;
      state.errorConfirmPayment = false;
      state.isLoadingConfirmPayment = false;
    },

    // ---------------------------
    // upgrade_quote (POST)
    // ---------------------------
    startUpgradeQuote: (state) => {
      state.isLoadingUpgradeQuote = true;
      state.errorUpgradeQuote = false;
    },
    upgradeQuoteSuccess: (state, action) => {
      state.upgradeQuote = action.payload;
      state.isLoadingUpgradeQuote = false;
    },
    upgradeQuoteError: (state, action) => {
      state.errorUpgradeQuote = action.payload || true;
      state.isLoadingUpgradeQuote = false;
    },
    resetUpgradeQuote: (state) => {
      state.upgradeQuote = null;
      state.errorUpgradeQuote = false;
      state.isLoadingUpgradeQuote = false;
    },

    // ---------------------------
    // create_upgrade_intent (POST)
    // ---------------------------
    startCreateUpgradeIntent: (state) => {
      state.isLoadingCreateUpgradeIntent = true;
      state.errorCreateUpgradeIntent = false;
    },
    createUpgradeIntentSuccess: (state, action) => {
      state.upgradePaymentIntent = action.payload;
      state.isLoadingCreateUpgradeIntent = false;
    },
    createUpgradeIntentError: (state, action) => {
      state.errorCreateUpgradeIntent = action.payload || true;
      state.isLoadingCreateUpgradeIntent = false;
    },
    resetCreateUpgradeIntent: (state) => {
      state.upgradePaymentIntent = null;
      state.errorCreateUpgradeIntent = false;
      state.isLoadingCreateUpgradeIntent = false;
    },

    // ---------------------------
    // confirm_upgrade_after_payment (POST)
    // ---------------------------
    startConfirmUpgradeAfterPayment: (state) => {
      state.isLoadingConfirmUpgradeAfterPayment = true;
      state.errorConfirmUpgradeAfterPayment = false;
    },
    confirmUpgradeAfterPaymentSuccess: (state, action) => {
      state.confirmUpgradeAfterPaymentResult = action.payload;
      state.isLoadingConfirmUpgradeAfterPayment = false;
    },
    confirmUpgradeAfterPaymentError: (state, action) => {
      state.errorConfirmUpgradeAfterPayment = action.payload || true;
      state.isLoadingConfirmUpgradeAfterPayment = false;
    },
    resetConfirmUpgradeAfterPayment: (state) => {
      state.confirmUpgradeAfterPaymentResult = null;
      state.errorConfirmUpgradeAfterPayment = false;
      state.isLoadingConfirmUpgradeAfterPayment = false;
    },

    // ---------------------------
    // helpers
    // ---------------------------
    clearAllPaymentErrors: (state) => {
      state.errorCreatePaymentIntent = false;
      state.errorConfirmSubscription = false;
      state.errorVerifySubscription = false;
      state.errorSubscriptionStatus = false;
      state.errorCancelSubscription = false;
      state.errorResumeSubscription = false;
      state.errorInvoices = false;
      state.errorConfirmPayment = false;
      state.errorUpgradeQuote = false;
      state.errorCreateUpgradeIntent = false;
      state.errorConfirmUpgradeAfterPayment = false;
    },
    resetAllPaymentState: () => initialState,
  },
});

export const {
  // create_payment_intent
  startCreatePaymentIntent,
  createPaymentIntentSuccess,
  createPaymentIntentError,
  resetCreatePaymentIntent,

  // confirm_subscription
  startConfirmSubscription,
  confirmSubscriptionSuccess,
  confirmSubscriptionError,
  resetConfirmSubscription,

  // verify_subscription
  startVerifySubscription,
  verifySubscriptionSuccess,
  verifySubscriptionError,
  resetVerifySubscription,

  // subscription_status
  startSubscriptionStatus,
  subscriptionStatusSuccess,
  subscriptionStatusError,
  resetSubscriptionStatus,

  // cancel_subscription
  startCancelSubscription,
  cancelSubscriptionSuccess,
  cancelSubscriptionError,
  resetCancelSubscription,

  // resume_subscription
  startResumeSubscription,
  resumeSubscriptionSuccess,
  resumeSubscriptionError,
  resetResumeSubscription,

  // invoices
  startListInvoices,
  listInvoicesSuccess,
  listInvoicesError,
  resetInvoices,

  // confirm_payment
  startConfirmPayment,
  confirmPaymentSuccess,
  confirmPaymentError,
  resetConfirmPayment,

  // upgrade_quote
  startUpgradeQuote,
  upgradeQuoteSuccess,
  upgradeQuoteError,
  resetUpgradeQuote,

  // create_upgrade_intent
  startCreateUpgradeIntent,
  createUpgradeIntentSuccess,
  createUpgradeIntentError,
  resetCreateUpgradeIntent,

  // confirm_upgrade_after_payment
  startConfirmUpgradeAfterPayment,
  confirmUpgradeAfterPaymentSuccess,
  confirmUpgradeAfterPaymentError,
  resetConfirmUpgradeAfterPayment,

  // helpers
  clearAllPaymentErrors,
  resetAllPaymentState,
} = paymentsSlice.actions;

export default paymentsSlice;
